import { apiDelete, apiGet, apiPost, apiPut } from './api-service';
import { getUserDetails } from './session-service';

export async function getAllEquipmentChecklist() {
    try {
        const response = await apiGet('core', `equipment-checklist`);
        return response;
    } catch (e) { }
}

export async function getEquipmentChecklist(id?: string) {
    try {
        const response = await apiGet('core', `equipment-checklist/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}


export async function addEquipmentChecklist(newDetails: any) {
    try {
        const response = await apiPost('core', `equipment-checklist`, newDetails);
        return response;
    } catch (e) { }
}

export async function updateEquipmentChecklist(newDetails: any, id?: string) {
    try {
        if (!id) {
            id = getUserDetails().client_id;
        }
        const response = await apiPut('core', `equipment-checklist/${id}`, newDetails);

        return response;
    } catch (e) { }
}

export async function removeEquipmentChecklist(id: any) {
    try {

        return await apiDelete('core', `equipment-checklist/${id}`);
    } catch (e) { }
}